<ng-container *ngIf="isCookieBanner; then cookieTemplate else emptyTemplate"></ng-container>
<ng-template #cookieTemplate>
  <!--Background unclickable-->
  <div class="disable"></div>

  <div class="container">
    <div class="cookie-notification">
      <div class="language-container">
        <a mat-icon-button [ngClass]="['mat-icon-button', 'mainFooter-nav', 'ya-body-1']"
          (click)="openLanguageDialog()">
          <div a11y_Button class="inline-icon ya-language-icon"
            [inlineSVG]="'shop-icons.svg#ya-flag-' + (currentLocale || 'de')"></div>
        </a>
      </div>
      <h2 class="ya-typography banner-title" langkey="phCookieBanner_Title"></h2>
      <div class="banner">
        <div class="ya-dialog-content">
          <p langkey="phCookieBanner_Content"></p>
        </div>
        <div class="ya-button-group-wrapper">
          <ng-container
            *ngIf="selectableCookies; then selectableCookiesTemplate else noSelectableCookiesTemplate"></ng-container>
          <ng-template #noSelectableCookiesTemplate>
            <div class="ya-button-group-container">
              <div class="ya-button-container">
                <button a11y_Button mat-flat-button (click)="acceptCookies(false)"><span
                    langkey="phCookieStatement_Button_Close"></span></button>
              </div>
              <div class="ya-button-container">
                <button a11y_Button mat-stroked-button (click)="openCookieDialog()"><span
                    langkey="phCookieBanner_Button_Infos"></span></button>
              </div>
            </div>
          </ng-template>
          <ng-template #selectableCookiesTemplate>
            <div class="ya-button-group-container">
              <div class="ya-button-container">
                <button a11y_Button mat-flat-button (click)="acceptCookies(true)">
                  <span langkey="phCookieBanner_Button_Accept"></span>
                </button>
              </div>
              <div class="ya-button-container">
                <button a11y_Button mat-stroked-button (click)="acceptCookies(false)">
                  <span langkey="phCookieBanner_Button_Deny"></span>
                </button>
              </div>
              <div class="ya-button-container">
                <button a11y_Button mat-stroked-button (click)="openCookieDialog()">
                  <span langkey="phCookieBanner_Button_Infos"></span>
                </button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #emptyTemplate>

</ng-template>